
interface PageEventProps {
  action: string;
  category: string;
  event_label: string;
  event_action: string;
}

export const Event = ({action, category, event_label, event_action}: PageEventProps) => {
  // @ts-ignoreq
  window?.gtag('event', action, {
    category,
    event_category: category,
    event_label,
    label: event_label,
    action: event_action,
    value: action
  });
  return { action, category, event_label, event_action };
};